import axios from 'axios';
import { IPublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
import { env } from './envConfig';
import { tokenRequest } from '../authConfig';

let msalInstance: IPublicClientApplication | null = null;

export function setAdminMsalInstance(instance: IPublicClientApplication) {
    msalInstance = instance;
}

export const axiosAdminApiInstance = axios.create({
    baseURL: `${env.REACT_APP_BACKEND_APP_NAME}`,
});

axiosAdminApiInstance.interceptors.request.use(
    async (config) => {
        let token: string | null = null;
        if (msalInstance) {
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length === 0) {
                console.warn('[AdminAPI] No MSAL accounts found — admin token cannot be acquired');
            } else {
                try {
                    const result = await msalInstance.acquireTokenSilent({
                        ...tokenRequest,
                        account: accounts[0],
                    });
                    token = result.accessToken;
                } catch (silentErr) {
                    console.warn('[AdminAPI] acquireTokenSilent failed, trying popup:', silentErr);
                    try {
                        const result = await msalInstance.acquireTokenPopup({
                            ...tokenRequest,
                            account: accounts[0],
                        });
                        token = result.accessToken;
                    } catch (popupErr) {
                        console.error('[AdminAPI] acquireTokenPopup also failed:', popupErr);
                    }
                }
            }
        } else {
            console.warn('[AdminAPI] MSAL instance not set — was setAdminMsalInstance() called?');
        }
        config.headers = {
            ...config.headers,
            Authorization: token ? `Bearer ${token}` : '',
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
        };
        return config;
    },
    (error: any) => Promise.reject(error)
);
